// extracted by mini-css-extract-plugin
export default {"label":"NonLiveLabel_label__byr1O"};